import { Link, useSidebarOpenState } from '@backstage/core-components';
import { LogoIcon } from '@ns/plugin-ns-theme';

import styles from './sidebar-logo.module.css';

/**
 * Brand slot at the top of the Backstage sidebar: the NS tile, plus the
 * "Developer Portal" title while the sidebar is open.
 *
 * @remarks
 * The slot sets no width, height offset or inset of its own. The drawer gives
 * every slot the same inset of 16, so the tile sits at x=16 in both states.
 * During the width animation the title is clipped by the slot, not moved.
 */
export const SidebarLogo = () => {
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={styles.root}>
      {/* The name contains the visible title, so a voice user can say it. */}
      <Link
        aria-label="Developer Portal home"
        className={styles.link}
        to="/"
        underline="none"
      >
        <LogoIcon decorative className={styles.tile} />
        {isOpen && <span className={styles.title}>Developer Portal</span>}
      </Link>
    </div>
  );
};
